document.addEventListener("DOMContentLoaded", () => {
    const tabContainers = document.querySelectorAll(".js-tabs");
    if (!tabContainers.length) {
        return;
    }

    tabContainers.forEach((tabsElement) => {
        const triggerElements = tabsElement.querySelectorAll("[data-trigger-tab]");
        if (!triggerElements.length) {
            return;
        }

        const itemElements = () => tabsElement.querySelectorAll("[data-tab]");

        triggerElements.forEach((triggerElement) => {
            triggerElement.addEventListener("click", () => {
                const targetKey = triggerElement.getAttribute("data-trigger-tab");
                try {
                    const safeKey = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(targetKey) : String(targetKey).replace(/"/g, '\\"');
                    const targetItem = tabsElement.querySelector(`[data-tab="${safeKey}"]`);

                    if (!targetItem) {
                        throw new Error(`No element found with data-tab="${targetKey}" within this .js-tabs`);
                    }

                    // Deactivate all triggers and items within this tabs instance
                    triggerElements.forEach((el) => el.classList.remove("-active"));
                    itemElements().forEach((el) => el.classList.remove("-active"));

                    // Activate the clicked trigger and its target item
                    triggerElement.classList.add("-active");
                    targetItem.classList.add("-active");
                } catch (error) {
                    // Catch and report any issue without breaking the page
                    // eslint-disable-next-line no-console
                    console.warn("[tabs] Unable to activate tab:", error);
                }
            });
        });
    });
});